import { getUrl } from '../../config';
import React from "react";
import styled from "@emotion/styled";
import { Link } from "react-router-dom"; // Ajout de l'importation
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Tooltip, Badge, Avatar, Typography, Box } from "@mui/material";

import useAuth from "../../hooks/useAuth";

const Footer = styled.div`
  background-color: transparent !important;
  padding: ${(props) => props.theme.spacing(4)};
  border-top: 1px solid rgba(255, 255, 255, 0.05);
`;

const ProfileCard = styled.div`
  display: flex;
  align-items: center;
  padding: ${(props) => props.theme.spacing(2.5, 3)};
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.04);
  transition: all 0.2s ease-in-out;

  &:hover {
    background: rgba(255, 255, 255, 0.07);
    border-color: rgba(255, 255, 255, 0.08);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
`;

const FooterText = styled(Typography)`
  color: #fff;
  font-weight: 600;
  font-size: 0.825rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const FooterSubText = styled(Typography)`
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.725rem;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  padding: 1px 0 0;
`;

const FooterBadge = styled(Badge)`
  span {
    background-color: ${(props) =>
      props.theme.sidebar.footer.online.background};
    border: 2px solid #111827;
    height: 10px;
    width: 10px;
    border-radius: 50%;
  }
`;

const SidebarFooter = ({ ...rest }) => {
  const { user } = useAuth();
  const uploadedImage = localStorage.getItem('uploadedImage');
  const userId = localStorage.getItem('userId');
  const profilId = localStorage.getItem('profilId');
  const [users, setUsers] = useState(null);

  const getProfil = async () => {
    try {
      const response = await axios.get(getUrl() + `/api/profiles/getProfilByUser/` + userId)
      if (response.data.status === 'success') {
        localStorage.setItem("profilId", response.data.data.id)
      } else {
        console.error('Erreur lors de la récupération du profil: ', response.data.message);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération du profil :", error);
    } finally {
      
    }
  };

  const fetchUser = async () => {
    try {
      const response = await axios.get(getUrl() + `/api/user/getMe`);
      if (response.data.status === 'success') {
        setUsers(response.data.user);
        console.log("aaa", response.data.user)
      } else {
        console.error('Erreur lors de la récupération des Users: ', response.data.message);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des Users :", error);
    } finally {
      
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  React.useEffect(
    () => {
      getProfil();
    },
    []
  )

  return (
    <Footer {...rest}>
      {!!user && users && (
        <Link to={"/profile/" + profilId} style={{ textDecoration: 'none', display: 'block' }}>
          <ProfileCard>
            <FooterBadge
              overlap="circular"
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              variant="dot"
            >
              <Avatar alt={user.username} src={uploadedImage || user.avatar} sx={{ width: 34, height: 34 }} />
            </FooterBadge>
            <Box sx={{ minWidth: 0, flex: 1, ml: 2 }}>
              <FooterText variant="body2">{users.firstname} {users.lastname}</FooterText>
              <Tooltip title={users.erpName || ''} arrow>
                <FooterSubText variant="caption">
                  {users.erpName}
                </FooterSubText>
              </Tooltip>
            </Box>
          </ProfileCard>
        </Link>
      )}
    </Footer>
  );
};
export default SidebarFooter;
